import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardSocialItemElement,
} from "@easy-email-pro-core/typings";
import { SocialElement } from "@easy-email-pro-core/components";
import React from "react";

import { SocialElement as SourceElement } from "../../basic/SocialElement";

const defaultData: ElementDefinition<StandardSocialItemElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardSocialElement = createBlock<StandardSocialItemElement>({
  get name() {
    return t("Social Item");
  },
  defaultData,
  type: ElementType.STANDARD_SOCIAL_ELEMENT,
  create: (payload) => {
    const defaultData: StandardSocialItemElement = {
      type: ElementType.STANDARD_SOCIAL_ELEMENT,
      data: {
        content: "",
      },
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.SOCIAL_ELEMENT,
  render(params) {
    const { node } = params;
    return (
      <SocialElement
        idx={params.idx}
        {...node.attributes}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
